// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.review-order-page {
  max-width: 66.66%;
  padding-bottom: 30px;
}

.review-page {
  margin: 0 20%;
  margin-bottom: 20px;
}

.mar-top-20 {
  margin-top: 20px;
}

.marleft-20 {
  margin-left: 20px;
}

.otc-line-items {
  margin-bottom: 20px;
  text-indent: 30px;
}

.container-box {
  padding-left: 20px;
  padding-right: 20px;
}

.icon-retail-offers {
  text-indent: 0;
  font-size: 25px;
  color: hsl(150, 100%, 24%);
  float: left;
  margin-right: 10px;
  line-height: inherit;
}

.est-discount {
  margin-top: -5px;
}
.est-discount.no-top-margin {
  margin-top: 20px;
}

.est-img {
  float: left;
  text-indent: 0px;
  margin-left: 30px;
}

section {
  margin-bottom: 30px;
}

.qty-error {
  margin-bottom: 0;
  margin-left: 15px;
}

.table-heading {
  margin-bottom: -10px;
}

.product-details p {
  margin-bottom: 20px;
}
.product-details h2 {
  margin-bottom: 20px;
}
.product-details .price-value {
  color: #191919;
  font-size: 24px;
  margin-bottom: 0;
}
@media (max-width: 1024px) {
  .product-details .price-value {
    font-size: 13px;
  }
}

.onetime-charges {
  color: #191919;
  margin-bottom: 0;
}

.total-price {
  color: #191919;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: -9px;
}

.clear-cart {
  font-size: 24px;
  margin-left: 5%;
}

.otc-spacing {
  margin-bottom: 10px;
}

button.btn-update {
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  font: 1.8rem "Omnes-ATT-W02-Medium";
  margin: 0 -15px;
  padding: 7px 8px 5px 7px;
  width: 100%;
}
button.btn-update:hover {
  outline: 1px dotted white;
}
@media (max-width: 1024px) {
  button.btn-update {
    margin: 10px 0;
  }
}

.display-name {
  font-size: 18px;
  font-weight: bold;
}

hr {
  margin: 20px 0;
}

.top {
  margin: 20px 0;
}

.order-id {
  margin-bottom: 30px;
}

hr.checkout-spacing {
  margin: 0 -15px 30px;
}
@media (max-width: 1024px) {
  hr.checkout-spacing {
    margin: 0 0 20px;
  }
}

.cart-links {
  margin-bottom: 5px;
}

.checkout-area {
  margin: auto -15px;
}

.btn-shopping {
  margin-bottom: 30px;
}

.manage-btn {
  margin-bottom: 20px;
}

@media (max-width: 1024px) {
  .review-order-page {
    max-width: 100%;
    padding-bottom: 0;
  }
  .container-box {
    padding-left: 15px;
    padding-right: 15px;
  }
  .review-page {
    margin: 0 auto;
  }
  .btn-checkout {
    margin: 0;
    width: 100%;
  }
  .btn-shopping {
    margin: 20px 0 30px;
    text-align: center;
    width: 100%;
  }
  .price-value {
    font-size: 16px;
  }
  .order-confirm {
    margin: 20px 0;
  }
  .success-msg {
    margin-bottom: 20px;
  }
  .total-price {
    display: block;
    font-size: 15px;
    text-align: right;
  }
  .clear-cart {
    float: right;
    font-size: 20px;
  }
  h2 {
    font-size: 18px;
    margin-bottom: 20px;
  }
  .top {
    margin: 10px 0 20px;
  }
  .checkout-spacing {
    margin: 20px -15px;
  }
  .continue-shopping {
    padding-top: 10px;
    text-align: center;
  }
  .checkout-area {
    margin: auto;
  }
  .manage-btn {
    margin-bottom: 30px;
  }
}
.tnc {
  padding: 10px 0;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/manage-product/review-order-product/review-order-product.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAhJA;EACE,iBAAA;EACA,oBAAA;AAkJF;;AA/IA;EACE,aAAA;EACA,mBAAA;AAkJF;;AA/IA;EACE,gBAAA;AAkJF;;AAhJA;EACE,iBAAA;AAmJF;;AAjJA;EACM,mBAAA;EACA,iBAAA;AAoJN;;AAlJA;EACE,kBAAA;EACA,mBAAA;AAqJF;;AAnJA;EACE,cAAA;EACA,eAAA;EACA,0BAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;AAsJF;;AApJA;EACE,gBAAA;AAuJF;AAtJE;EACG,gBAAA;AAwJL;;AApJA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;AAuJF;;AAnJA;EACE,mBAAA;AAsJF;;AAnJA;EACE,gBAAA;EACA,iBAAA;AAsJF;;AApJA;EACE,oBAAA;AAuJF;;AAjJE;EACE,mBAAA;AAoJJ;AAjJE;EACE,mBAAA;AAmJJ;AAhJE;EAIE,cAAA;EACA,eAAA;EACA,gBAAA;AA+IJ;AFrMI;EEgDF;IAEI,eAAA;EAuJJ;AACF;;AAhJA;EACE,cAAA;EACA,gBAAA;AAmJF;;AA/IA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAkJF;;AA/IA;EACE,eAAA;EACA,eAAA;AAkJF;;AA/IA;EACE,mBAAA;AAkJF;;AA9IE;EFrEE,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EEuEA,mCAAA;EACA,eAAA;EACA,wBAAA;EACA,WAAA;AAqJJ;AAnJI;EACE,yBAAA;AAqJN;AF9OI;EEiFF;IAYI,cAAA;EAqJJ;AACF;;AAjJA;EACA,eAAA;EACA,iBAAA;AAoJA;;AAjJA;EACE,cAAA;AAoJF;;AAjJA;EACE,cAAA;AAoJF;;AAjJA;EACE,mBAAA;AAoJF;;AAjJA;EACE,oBAAA;AAoJF;AFxQI;EEmHJ;IAII,gBAAA;EAqJF;AACF;;AAlJA;EACE,kBAAA;AAqJF;;AAlJA;EACE,kBAAA;AAqJF;;AAlJA;EACE,mBAAA;AAqJF;;AAlJA;EACE,mBAAA;AAqJF;;AF7RI;EE4IF;IACE,eAAA;IACA,iBAAA;EAqJF;EAlJA;IACE,kBAAA;IACA,mBAAA;EAoJF;EAjJA;IACE,cAAA;EAmJF;EAhJA;IACE,SAAA;IACA,WAAA;EAkJF;EA/IA;IACE,mBAAA;IACA,kBAAA;IACA,WAAA;EAiJF;EA9IA;IACE,eAAA;EAgJF;EA7IA;IACE,cAAA;EA+IF;EA5IA;IACE,mBAAA;EA8IF;EA3IA;IACE,cAAA;IACA,eAAA;IACA,iBAAA;EA6IF;EA1IA;IACE,YAAA;IACA,eAAA;EA4IF;EAzIA;IACE,eAAA;IACA,mBAAA;EA2IF;EAxIA;IACE,mBAAA;EA0IF;EAvIA;IACE,kBAAA;EAyIF;EAtIA;IACE,iBAAA;IACA,kBAAA;EAwIF;EArIA;IACE,YAAA;EAuIF;EApIA;IACE,mBAAA;EAsIF;AACF;AApIA;EACE,eAAA;AAsIF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n// Cart component page\n.review-order-page {\n  max-width: 66.66%;\n  padding-bottom: 30px;\n}\n\n.review-page {\n  margin: 0 20%;\n  margin-bottom: 20px;\n}\n\n.mar-top-20 {\n  margin-top: 20px;\n}\n.marleft-20 {\n  margin-left: 20px;\n}\n.otc-line-items {\n      margin-bottom: 20px;\n      text-indent: 30px;\n}\n.container-box {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n.icon-retail-offers {\n  text-indent: 0;\n  font-size: 25px;\n  color: color(success, base);\n  float: left;\n  margin-right: 10px;\n  line-height: inherit;\n}\n.est-discount{\n  margin-top: -5px;\n  &.no-top-margin {\n     margin-top: 20px;\n  }\n}\n\n.est-img{\n  float: left;\n  text-indent: 0px;\n  margin-left: 30px;\n}\n\n\nsection {\n  margin-bottom: 30px;\n}\n\n.qty-error {\n  margin-bottom: 0;\n  margin-left: 15px;\n}\n.table-heading {\n  margin-bottom: -10px;\n}\n\n// Cart Style Starts\n\n.product-details {\n  p {\n    margin-bottom: 20px;\n  }\n\n  h2 {\n    margin-bottom: 20px;\n  }\n\n  .price-value {\n    @include respond-to(small) {\n      font-size: 13px;\n    }\n    color: color(inverse, darker);\n    font-size: 24px;\n    margin-bottom: 0;\n   }\n }\n\n.onetime-charges {\n  color: color(inverse, darker);\n  margin-bottom: 0;\n}\n\n\n.total-price {\n  color: color(inverse, darker);\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: -9px;\n}\n\n.clear-cart {\n  font-size: 24px;\n  margin-left: 5%;\n}\n\n.otc-spacing {\n  margin-bottom: 10px;\n}\n\nbutton {\n  &.btn-update {\n    @include vendor-prefix('border-radius', 8px);\n    font: 1.8rem 'Omnes-ATT-W02-Medium'; //TODO: change this to 1.7rem when changing fonts to Aleck\n    margin: 0 -15px;\n    padding: 7px 8px 5px 7px;\n    width: 100%;\n\n    &:hover {\n      outline: 1px dotted color(default, light);\n    }\n\n    @include respond-to(small) {\n      margin: 10px 0;\n    }\n  }\n}\n\n.display-name {\nfont-size: 18px;\nfont-weight:bold; \n}\n\nhr {\n  margin: 20px 0;\n}\n\n.top {\n  margin: 20px 0;\n}\n\n.order-id {\n  margin-bottom: 30px;\n}\n\nhr.checkout-spacing {\n  margin: 0 -15px 30px;\n\n  @include respond-to(small) {\n    margin: 0 0 20px;\n  }\n}\n\n.cart-links {\n  margin-bottom: 5px;\n}\n\n.checkout-area {\n  margin: auto -15px;\n}\n\n.btn-shopping {\n  margin-bottom: 30px;\n}\n\n.manage-btn {\n  margin-bottom: 20px;\n  }\n\n@include respond-to(small) {\n  .review-order-page {\n    max-width: 100%;\n    padding-bottom: 0;\n  }\n\n  .container-box {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n\n  .review-page {\n    margin: 0 auto;\n  }\n\n  .btn-checkout {\n    margin: 0;\n    width: 100%;\n   }\n\n  .btn-shopping {\n    margin: 20px 0 30px;\n    text-align: center;\n    width: 100%;\n   }\n\n  .price-value {\n    font-size: 16px;\n   }\n\n  .order-confirm {\n    margin: 20px 0;\n  }\n\n  .success-msg {\n    margin-bottom: 20px;\n  }\n\n  .total-price {\n    display: block;\n    font-size: 15px;\n    text-align: right;\n   }\n\n  .clear-cart {\n    float: right;\n    font-size: 20px;\n   }\n\n  h2 {\n    font-size: 18px;\n    margin-bottom: 20px;\n   }\n\n  .top {\n    margin: 10px 0 20px;\n  }\n\n  .checkout-spacing {\n    margin: 20px -15px;\n  }\n\n  .continue-shopping {\n    padding-top: 10px;\n    text-align: center;\n }\n\n  .checkout-area {\n    margin: auto;\n  }\n\n  .manage-btn {\n    margin-bottom: 30px;\n  }\n}\n.tnc {\n  padding: 10px 0;\n}\n\n// Cart Style Ends\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
